import React from 'react'

export const PersonFilled: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, ...restProps }) => {
    return (
        <svg
            width={width || '24'}
            height={height || '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <mask
                id="mask0_1418_9065"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1418_9065)">
                <path
                    d="M12.4528 11.2453C11.4465 11.2453 10.5912 10.8931 9.88679 10.1887C9.18239 9.48428 8.83019 8.62893 8.83019 7.62264C8.83019 6.63648 9.18239 5.78596 9.88679 5.07109C10.5912 4.35703 11.4465 4 12.4528 4C13.4591 4 14.3145 4.35703 15.0189 5.07109C15.7233 5.78596 16.0755 6.63648 16.0755 7.62264C16.0755 8.62893 15.7233 9.48428 15.0189 10.1887C14.3145 10.8931 13.4591 11.2453 12.4528 11.2453ZM19.6377 20H5.26792C4.90566 20 4.60377 19.8792 4.36226 19.6377C4.12075 19.3962 4 19.0943 4 18.7321V18.0075C4 17.5044 4.14611 17.0363 4.43834 16.6032C4.72976 16.1709 5.11698 15.834 5.6 15.5925C6.74717 15.0491 7.88951 14.6413 9.02702 14.3692C10.1637 14.0979 11.3057 13.9623 12.4528 13.9623C13.6 13.9623 14.7423 14.0979 15.8798 14.3692C17.0166 14.6413 18.1585 15.0491 19.3057 15.5925C19.7887 15.834 20.1763 16.1709 20.4685 16.6032C20.76 17.0363 20.9057 17.5044 20.9057 18.0075V18.7321C20.9057 19.0943 20.7849 19.3962 20.5434 19.6377C20.3019 19.8792 20 20 19.6377 20ZM5.20755 18.7925H19.6981V18.0075C19.6981 17.7258 19.6128 17.469 19.4421 17.2371C19.2706 17.0061 19.034 16.8101 18.7321 16.6491C17.7258 16.166 16.6945 15.7989 15.6383 15.5478C14.5813 15.2958 13.5195 15.1698 12.4528 15.1698C11.3862 15.1698 10.3247 15.2958 9.26853 15.5478C8.21152 15.7989 7.17987 16.166 6.17359 16.6491C5.8717 16.8101 5.63542 17.0061 5.46475 17.2371C5.29328 17.469 5.20755 17.7258 5.20755 18.0075V18.7925ZM12.4528 10.0377C13.117 10.0377 13.6857 9.80106 14.1591 9.3277C14.6316 8.85514 14.8679 8.28679 14.8679 7.62264C14.8679 6.95849 14.6316 6.39014 14.1591 5.91758C13.6857 5.44423 13.117 5.20755 12.4528 5.20755C11.7887 5.20755 11.2203 5.44423 10.7478 5.91758C10.2744 6.39014 10.0377 6.95849 10.0377 7.62264C10.0377 8.28679 10.2744 8.85514 10.7478 9.3277C11.2203 9.80106 11.7887 10.0377 12.4528 10.0377Z"
                    fill="#808080"
                />
            </g>
        </svg>
    )
}
